import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { provide } from 'vue'
import { CoachingSessionStoreKey } from './CoachingSessionStore.interfaces'
import { createCoachingSessionStore } from './CoachingSessionStore.composition'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionStore',
  setup(__props) {

const coachingSessionStore = createCoachingSessionStore()
provide(CoachingSessionStoreKey, coachingSessionStore)

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { store: _unref(coachingSessionStore) })
}
}

})